import { createFileRoute } from '@tanstack/react-router';
import { StocktakeScreen } from '@/features/stocktake/StocktakeScreen';

export const Route = createFileRoute('/_app/stocktake')({
  component: StocktakeScreen,
});
